import type { BackendRouteDefinition } from '../types';

export interface SyncTalkrouteCommunicationEventsRequestData {
  sinceIso?: string;
}

export interface TalkrouteSettingsData {
  accountId: string;
  apiKey: string;
  earliestSyncDateIso: string | null;
  lastSyncedAtIso: string | null;
}

export interface SaveTalkrouteSettingsData {
  accountId: string;
  apiKey: string;
}

export interface TalkrouteVirtualNumberData {
  phoneNumber: string;
  description?: string;
}
export interface ListTalkrouteVirtualNumbersData {
  virtualNumbers: TalkrouteVirtualNumberData[];
}

export type SyncTalkrouteCommunicationEventsResult =
  | {
      status: 'success';
      scannedRecords: number;
      createdCommunicationEvents: number;
      skippedRecords: number;
      skippedReasons: Record<string, number>;
      sinceIso: string;
      untilIso: string;
      lastSyncedAtIso: string | null;
    }
  | {
      status: 'error';
      error: string;
    };

// Served by api-longrun-node. The `/api/firms/talkroute{,/**}` Hosting
// rewrite and matching Vite proxy keep this route off the api-core fallback.
export const listTalkrouteVirtualNumbersRoute = {
  transport: 'api',
  method: 'GET',
  path: '/firms/talkroute/virtual-numbers',
} as const satisfies BackendRouteDefinition;

export const getTalkrouteSettingsRoute = {
  transport: 'api',
  method: 'GET',
  path: '/firms/talkroute/settings',
} as const satisfies BackendRouteDefinition;

export const saveTalkrouteSettingsRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/talkroute/settings',
  body: (requestData: SaveTalkrouteSettingsData) => requestData,
} as const satisfies BackendRouteDefinition;

export const syncTalkrouteCommunicationEventsRoute = {
  transport: 'api',
  method: 'POST',
  path: '/firms/talkroute/sync',
  body: (
    requestData: SyncTalkrouteCommunicationEventsRequestData | undefined,
  ) => requestData ?? {},
} as const satisfies BackendRouteDefinition;
